import SubsectionHeader from '../components/subsection-header/subsection-header';
import SubsectionFooter from '../components/subsection-footer/subsection-footer';
import FinancialKeyMotivator from './financial-key-motivator';
import FinancialSummary from './financial-summary';
import { Routes, Route, Link, Outlet, useLocation } from 'react-router-dom';
import './financial.scss';
import { useState, useEffect, useRef } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";

// References for Financial Section
const financialUsageReferences = [
  {reference: "“Direct Mail Industry Research: Insights Report,” Summit Research for McCann Worldgroup, May 2023."},
  {reference: "USPSDelivers.com Research — Full Report, Qualitative and Quantitative Results, Summit Research, February 2021."}
];

const financialPlanningReferences = [
  {reference: "“Direct Mail Industry Research: Insights Report,” Summit Research for McCann Worldgroup, May 2023."},
  {reference: "Participation in USPS Connect Local requires agreement to program terms and entry of packages and mail close to final destination. Same-day delivery is expected but not guaranteed and may not be available at all locations. Next-day delivery may be impacted by holidays and availability of Sunday delivery. When Sunday delivery is available there is an additional fee for USPS Connect Local shipping services. Sunday delivery is not available for USPS Connect Local mail services. Additional restrictions may apply. Speak with your USPS<sup>&reg;</sup> Representative for details."}
];

const financialIntegrationReferences = [
  {reference: "“Direct Mail Industry Research: Insights Report,” Summit Research for McCann Worldgroup, May 2023."},
  {reference: "QR Code is a registered trademark of DENSO WAVE INCORPORATED."}
];

const financialMetricsReferences = [
  {reference: "“Direct Mail Industry Research: Insights Report,” Summit Research for McCann Worldgroup, May 2023."},
  {reference: "QR Code is a registered trademark of DENSO WAVE INCORPORATED."}
];

const financialFutureReferences = [
  {reference: "“Direct Mail Industry Research: Insights Report,” Summit Research for McCann Worldgroup, May 2023."},
  {reference: "QR Code is a registered trademark of DENSO WAVE INCORPORATED."},
  {reference: "“<a href='https://www.lob.com/blog/4-direct-mail-marketing-myths-debunked' target='_blank'>4 Direct Mail Marketing Myths Debunked</a>,” Lob, Oct. 4, 2022."}
];

export default function Financial(props) {

  const url = useLocation();
  const path = url.pathname;
  const segment = path.substring(path.lastIndexOf('/') + 1);
  const currentSection = "Financial";
  const keyTakeaways = false;
  const [subsection, setCurrentSubsection] = useState('usage');

  // Hero Headings
  const h1 = "Financial";
  const h2 = "Direct Mail in the Financial Industry:";
  const subtext = "Key Stats and Insights";
  const heroAlt = "Monochromatic blue shapes arranged across a gridded blue background.";

  // Initial References - Financial Usage 
  const [references, setReferences] = useState(financialUsageReferences);

  useEffect(() => {

    switch (segment) {
      case "financial": 
        setReferences(financialUsageReferences);
        setCurrentSubsection('usage');
        break;
      case "planning": 
        setReferences(financialPlanningReferences);
        setCurrentSubsection('planning');
        break;
      case "integration": 
        setReferences(financialIntegrationReferences);
        setCurrentSubsection('integration');
        break;
      case "metrics": 
        setReferences(financialMetricsReferences);
        setCurrentSubsection('metrics');
        break;
      case "future": 
        setReferences(financialFutureReferences);
        setCurrentSubsection('future');
        break;
    }
    
  }, [url]);

  useEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [url.pathname]);

  return (
    <>
      <div className={'financial ' + subsection}>
        <div className='container' data-aos="fade-up">
          <SubsectionHeader currentSection={currentSection} h1={h1} heroAlt={heroAlt} h2={h2} subtext={subtext}/>
          <Outlet />
          <SubsectionFooter currentSection={currentSection} KeyMotivator={FinancialKeyMotivator} Summary={FinancialSummary} references={references} keyTakeaways={keyTakeaways}  />
        </div>
      </div>
    </>
  );
}
